import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import { differenceInMinutes, differenceInSeconds } from 'date-fns';
import React, { useEffect, useState } from 'react';

const calcDuration = (startDate, endDate) => {
  const minutes = differenceInMinutes(endDate, startDate);
  const seconds = `0${differenceInSeconds(endDate, startDate) % 60}`.slice(-2);
  return `${minutes}:${seconds}`;
};

const Duration = ({ startDate, endDate, className }) => {
  const [duration, setDuration] = useState(null);

  const cn = useClassNames(() => [className], [className]);

  useEffect(() => {
    if (startDate) {
      let timeout;
      const update = () => {
        setDuration(calcDuration(startDate, endDate || new Date()));
        timeout = setTimeout(update, 1000);
      };

      update();

      return () => {
        clearTimeout(timeout);
      };
    }

    return undefined;
  }, [startDate, endDate]);

  return <div className={cn}>{duration}</div>;
};

Duration.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
};

Duration.defaultProps = {
  startDate: null,
  endDate: null,
};

export default Duration;
